import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { userLoggedOut } from "../../redux/features/auth/authSlice";
import usePageTitle from "../../utils/usePageTitle";
import {
  useEditAssignmentMarkMutation,
  useGetAssignmentMarksQuery,
} from "../../redux/features/assignments/assignmentMarkAPI";

export default function AssignmentMark() {
  usePageTitle("Assignment Marks");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const { role } = JSON.parse(localStorage.auth).user;

    if (role !== "admin") {
      navigate("/admin");

      dispatch(userLoggedOut());
      window.localStorage.clear();
    }
  }, [dispatch, navigate]);

  const [marks, setMarks] = useState("");
  const {
    data: assignmentMarks,
    isLoading,
    isError,
    error,
  } = useGetAssignmentMarksQuery();

  const [editAssignmentMark] = useEditAssignmentMarkMutation();

  let content = null;

  if (isLoading) {
    content = <div className="text-center mt-6">Loading...</div>;
  }
  if (!isLoading && isError) {
    <div className="text-center mt-6">{error}</div>;
  }
  if (!isLoading && !isError && assignmentMarks?.length === 0) {
    content = <div className="text-center mt-6">No assignment found!</div>;
  }

  if (!isLoading && !isError && assignmentMarks?.length > 0) {
    content = (
      <>
        <div className="overflow-x-auto mt-6">
          <table className="table-auto divide-y-1 text-base divide-gray-400 w-full divide-y divide-slate-600/50">
            <thead>
              <tr>
                <th className="table-th">Assignment</th>
                <th className="table-th">Date</th>
                <th className="table-th">Student Name</th>
                <th className="table-th">Repository Link</th>
                <th className="table-th">Mark</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-slate-600/50">
              {assignmentMarks.map((assignmentMark) => (
                <tr key={assignmentMark.id}>
                  <td className="table-td">{assignmentMark.title}</td>
                  <td className="table-td">
                    {`${new Date(
                      assignmentMark.createdAt
                    ).toLocaleDateString()} ${new Date(
                      assignmentMark.createdAt
                    ).toLocaleTimeString()}`}
                  </td>
                  <td className="table-td">{assignmentMark.student_name}</td>
                  <td className="table-td">{assignmentMark.repo_link}</td>
                  <td className="table-td input-mark flex justify-center">
                    {assignmentMark.status === "pending" ? (
                      <>
                        <input
                          max="100"
                          value={marks}
                          onChange={(e) => setMarks(e.target.value)}
                        />
                        <svg
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke-width="2"
                          stroke="currentColor"
                          className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400"
                          onClick={(e) =>
                            editAssignmentMark({
                              id: assignmentMark.id,
                              data: {
                                ...assignmentMark,
                                mark: parseInt(marks),
                                status: "published",
                              },
                            })
                          }
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4.5 12.75l6 6 9-13.5"
                          />
                        </svg>
                      </>
                    ) : (
                      assignmentMark.mark
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  }

  const total = assignmentMarks?.length;
  const pending = assignmentMarks?.reduce(
    (total, current) => (current.status === "pending" ? total + 1 : total),
    0
  );
  const sent = total - pending;

  return (
    <section className="py-6 bg-primary">
      <div className="mx-auto max-w-full px-5 lg:px-20">
        <div className="px-3 py-20 bg-opacity-10">
          <span className="px-3 text-2xl text-bold font-bold text-cyan">
            Assignment Mark
          </span>
          <ul className="assignment-status">
            <li>
              Total <span>{total}</span>
            </li>
            <li>
              Pending <span>{pending}</span>
            </li>
            <li>
              Mark Sent <span>{sent}</span>
            </li>
          </ul>
          {content}
        </div>
      </div>
    </section>
  );
}
